import { render, staticRenderFns } from "./BaseCommentCard.vue?vue&type=template&id=663bf850&scoped=true&"
import script from "./BaseCommentCard.vue?vue&type=script&lang=js&"
export * from "./BaseCommentCard.vue?vue&type=script&lang=js&"
import style0 from "./BaseCommentCard.vue?vue&type=style&index=0&id=663bf850&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663bf850",
  null
  
)

export default component.exports